/* eslint-disable no-multi-assign */
/* eslint-disable no-unused-expressions */
import vars from '../helpers';

const stopAllAudio = () => {
	$('.podcasts__item').each((index, elem) => {
		const audio = elem.querySelector('audio');
		const button = elem.querySelector('button');
		button.dataset.player = 'pause';
		audio.pause();
	});
};

export default class PodcastApi {
	constructor(element) {
		this.element = element;
		this.button = this.element.querySelector('button');
		this.name = this.button.dataset.name;
		this.audio = this.element.querySelector('audio');
		this.playerInterval = null;
		this.progress = null;
		this.progressSegment = this.element.querySelector('rect');
		this.svg = this.element.querySelector('.podcasts__progress');
		this.number = 100;
		this.isFirstPlaySend = true;
	}

	pause() {
		this.button.dataset.player = 'pause';
		this.audio.pause();
		this.clearInterval();
	}

	end() {
		vars.$window.trigger('audio-end', [this.name]);
		this.pause();
	}

	progressUpd() {
		this.progress = setInterval(() => {
			// let progress = Math.ceil(this.audio.currentTime / this.audio.duration * this.number);
			let progress = this.audio.currentTime / this.audio.duration * this.number;
			this.progressSegment.setAttribute('width', `${progress}%`);
			if (progress >= this.number) {
				progress = 0;
				this.progressSegment.setAttribute('width', '0');
				this.end();
			}
		}, 100);
	}

	play() {
		stopAllAudio();
		this.clearInterval();
		this.button.dataset.player = 'play';
		this.audio.play();
		this.progressUpd();
		this.playerInterval = setInterval(() => {
			vars.$window.trigger('audio-interval', [this.name]);
		}, 10000);

		if (this.isFirstPlaySend) {
			vars.$window.trigger('audio-play', [this.name]);
			this.isFirstPlaySend = false;
		}
	}
	reset() {
		this.progressSegment.setAttribute('width', '0');
		this.end();
		this.audio.currentTime = 0;
	}
	init() {
		this.element.addEventListener('click', (event) => {
			const target = event.target;
			if (!target.closest('.podcasts__progress')) {
				const status = this.button.dataset.player;
				status === 'pause' ? this.play() : this.pause();
			}
		});

		// this.svg.addEventListener('mousemove', (event) => {
		// 	const width = event.currentTarget.getBoundingClientRect().width;
		// 	const offsetX = event.offsetX;
		// 	const progress = offsetX / width * 100;
		// 	if (this.button.dataset.player === 'play') {
		// 		clearInterval(this.playerInterval);
		// 		clearInterval(this.progress);
		// 		this.progressSegment.setAttribute('width', `${progress}%`);
		// 	}
		// });

		// this.svg.addEventListener('mouseleave', () => {
		// 	if (this.button.dataset.player === 'play') {
		// 		clearInterval(this.progress);
		// 		this.progressUpd();
		// 	}
		// });

		this.svg.addEventListener('click', (event) => {
			const width = event.currentTarget.getBoundingClientRect().width;
			const offsetX = event.offsetX;
			const time = offsetX / width * this.audio.duration;
			if (this.button.dataset.player === 'play') {
				this.audio.currentTime = time;
			}
			this.play();
		});
	}

	clearInterval() {
		clearInterval(this.playerInterval);
		clearInterval(this.progress);
	}
}
